export const ru = {
  brand: {
    name: "Orda OS",
    tagline: "Операционная система кафе",
  },
  nav: {
    apps: "Приложения",
    features: "Возможности",
    caseStudy: "Кейс",
    pricing: "Тарифы",
    faq: "FAQ",
    deck: "Презентация",
    cta: "Подключить кафе",
    ctaShort: "Подключить",
  },
  rail: {
    ariaLabel: "Навигация по секциям",
  },
  hero: {
    eyebrow: "Операционная система кафе · Казахстан",
    nameMeaning: "Orda OS — единый штаб вашего заведения: меню, кухня, касса, доставка и склад в одном месте. Одна платформа вместо десятка программ.",
    serifLine: "меню, кухня, касса и склад — один организм",
    scrollHint: "Прокрутите — войдите внутрь",
    subtitle:
      "Гость сканирует QR и заказывает сам. Кухня видит заказ мгновенно. Касса, склад, аналитика и AI — в одной платформе. Без установки, запуск за один день.",
    ctaDemo: "Живое демо",
    ctaContact: "Подключить кафе",
    status: "Принимаем кафе — запуск за 1 день",
    glass: {
      platform: { label: "Платформа", value: "10 приложений" },
      launch: { label: "Запуск", value: "1 день под ключ" },
      langs: { label: "Языки", value: "Қазақша · Русский · English" },
    },
    stats: {
      apps: "приложений",
      features: "фишек",
      langs: "языка",
    },
    ticker: [
      "QR-меню",
      "AR-блюда в 3D",
      "Кухня realtime",
      "Касса и Kaspi QR",
      "AI-помощник",
      "Склад и закупки",
      "Бронирование",
      "Доставка",
      "Аналитика",
      "Қазақша · Русский · English",
    ],
  },
  apps: {
    label: "Приложения",
    title: "Одна платформа,",
    accent: "десять приложений",
    aside:
      "Каждому в кафе — свой экран: гостю, повару, кассиру, официанту, владельцу. Всё связано realtime: заказ гостя появляется на кухне быстрее, чем он положит телефон.",
    dragHint: "потяни, чтобы покрутить",
    openDemo: "Открыть демо",
    downloadCashier: "Скачать кассу для Windows",
    totalNote:
      "И это не всё: закупщик, приёмщик, кладовщик и курьер — всего {total} приложений в платформе.",
    items: {
      guest: {
        name: "Гостевое меню",
        role: "сканирует, выбирает, заказывает",
        desc:
          "QR на столе открывает меню с фото, 3D-блюдами в AR и AI-советчиком. Общая корзина на стол, оплата с телефона — официанта ждать не нужно.",
        tags: ["QR", "AR / 3D", "AI-советчик", "Общая корзина"],
      },
      kitchen: {
        name: "Кухня",
        role: "видит заказ мгновенно",
        desc:
          "Экран повара: новые заказы прилетают realtime, один тап — «готовится», второй — «готово». Официант сразу получает уведомление.",
        tags: ["KDS", "Realtime", "Статусы блюд"],
      },
      cashier: {
        name: "Касса",
        role: "смена, оплаты, чеки",
        desc:
          "Веб-касса со сменами, скидками и сплит-оплатой. Kaspi QR, наличные, карта — закрытие стола в три касания.",
        tags: ["Kaspi QR", "Сплит-оплата", "Смены"],
      },
      waiter: {
        name: "Официант",
        role: "столы в кармане",
        desc:
          "PWA на телефоне официанта: свои столы, вызовы гостей, заказы и статусы кухни. Push-уведомление — когда блюдо готово.",
        tags: ["PWA", "Push", "Вызов гостя"],
      },
      admin: {
        name: "Админ-панель",
        role: "цифры вместо ощущений",
        desc:
          "Меню, цены, стоп-лист, персонал, отзывы и аналитика: выручка, топ блюд, средний чек, воронка гостя — на одном экране.",
        tags: ["Аналитика", "Меню", "Персонал"],
      },
      booking: {
        name: "Бронирование",
        role: "столик заранее",
        desc:
          "Гость бронирует стол с предоплатой через Kaspi — ложные брони исчезают. Карта зала: кабинки, караоке, бильярд.",
        tags: ["Предоплата", "Карта зала"],
      },
    },
  },
  features: {
    label: "Возможности",
    title: "Что умеет",
    accent: "платформа",
    aside:
      "140+ фишек уже в продукте. Здесь — восемь, ради которых кафе переходят на Orda OS.",
    list: [
      {
        title: "QR-меню и AR",
        sub: "гостевой опыт",
        body:
          "Меню с фото на трёх языках открывается за секунду без приложения. У флагманских блюд — 3D-модель: гость наводит камеру и ставит виртуальную тарелку на свой стол. Такое меню продаёт само.",
        tags: ["3 языка", "AR", "Без приложения"],
      },
      {
        title: "Realtime-кухня",
        sub: "ноль потерянных заказов",
        body:
          "Заказ гостя появляется на экране кухни мгновенно — без бумажек и криков. Race-safe архитектура: два повара не возьмут одно блюдо дважды, статусы сходятся при любом интернете.",
        tags: ["KDS", "Realtime"],
      },
      {
        title: "Касса и оплаты",
        sub: "Kaspi QR · сплит · смены",
        body:
          "Гость платит со своего телефона через Kaspi QR, компания делит счёт на всех. Кассир видит смену, скидки, рефанды. Чеки печатаются на ESC/POS-принтер.",
        tags: ["Kaspi QR", "Сплит-оплата"],
      },
      {
        title: "Склад и закупки",
        sub: "закупщик → приёмщик → кладовщик",
        body:
          "Закупки с фото чека прямо с базара, приёмка с фиксацией расхождений, остатки и списания. Три роли — три отдельных приложения, владелец видит всю цепочку.",
        tags: ["Фото чека", "Расхождения"],
      },
      {
        title: "AI-помощники",
        sub: "гостю, повару, владельцу",
        body:
          "Гостю AI собирает ужин под бюджет «5000 ₸ на двоих». Повару подсказывает по смене. Владельцу отвечает на «сколько мы заработали в пятницу?» — на казахском и русском.",
        tags: ["GPT", "KZ / RU / EN"],
      },
      {
        title: "Telegram-алерты",
        sub: "кафе в кармане владельца",
        body:
          "Новый заказ, гость ушёл без оплаты, расхождение в приёмке, дневной отчёт — владелец получает всё в Telegram в момент события. Без открытия админки.",
        tags: ["Owner-алерты", "Отчёт дня"],
      },
      {
        title: "Лояльность и отзывы",
        sub: "гость возвращается",
        body:
          "Баллы за визиты, распознавание постоянных гостей, отзывы с фото после оплаты и колесо фортуны. Повторный гость — самый дешёвый маркетинг.",
        tags: ["Баллы", "Колесо фортуны"],
      },
      {
        title: "Доставка и курьер",
        sub: "за пределами зала",
        body:
          "Гость заказывает домой с той же витрины, курьер ведёт заказ в своём приложении с трекингом статусов и SOS-кнопкой.",
        tags: ["Доставка", "Трекинг"],
      },
    ],
  },
  process: {
    label: "Запуск",
    title: "Запуск за",
    accent: "один день",
    aside:
      "Подключение кафе не должно ощущаться как ремонт. Вот весь путь — от звонка до первых заказов через QR.",
    steps: [
      {
        when: "День 1 · утро",
        title: "Создаём кафе",
        body:
          "Заводим тенант, загружаем меню (можно по фото бумажного), цены, фото блюд и столы. Всё делаем мы — от вас только меню.",
      },
      {
        when: "День 1 · день",
        title: "QR на столы",
        body:
          "Печатаем QR-код на каждый стол. Токен ротируется после каждой оплаты — подделать или сохранить ссылку нельзя.",
      },
      {
        when: "День 1 · вечер",
        title: "Учим команду",
        body:
          "30 минут с официантами и кухней. Вход по PIN, никаких паролей и инструкций на 40 страниц. Вечером гости уже заказывают сами.",
      },
      {
        when: "Дальше",
        title: "Сопровождаем",
        body:
          "Алерты в Telegram, обновления без простоя, поддержка на казахском и русском. Платформа растёт — вы ничего не переустанавливаете.",
      },
    ],
    footnote:
      "Оборудование покупать не нужно: телефоны персонала и любой планшет на кухню — этого достаточно.",
  },
  caseAlem: {
    label: "Кейс",
    title: "Работает",
    accent: "в настоящем кафе",
    quote:
      "Первое кафе на платформе: QR-меню на столах, кухня на планшете, касса и склад — всё живое, не демо-стенд.",
    location: "Первый клиент платформы · live с мая 2026",
    liveBadge: "Живое кафе",
    stats: {
      dishes: "блюд в меню",
      tables: "столов с QR",
      staff: "сотрудников",
      ar: "блюда в AR",
    },
    cta: "Открыть меню Әлем",
    ctaNote: "Это настоящая витрина — то же меню видят гости за столами кафе.",
  },
  pricing: {
    label: "Тарифы",
    title: "Честные",
    accent: "цены",
    subtitle:
      "Без долгосрочных контрактов — отключиться можно в любой месяц. Цены запуска со скидкой, в тенге.",
    popular: "Популярный",
    perMonth: "/мес",
    promo: "Запуск",
    contactUs: "Обсудить",
    freeTrial: "15 дней бесплатно",
    validUntil: "Цены со скидкой действуют только до конца 2026 года",
    starter: {
      name: "Starter",
      price: "10 000 ₸",
      oldPrice: "16 000 ₸",
      currency: "",
      features: [
        "До 10 столов",
        "QR-меню гостям",
        "Один админ",
        "Базовая аналитика",
        "Email-поддержка",
      ],
      cta: "Подключить",
    },
    delivery: {
      name: "Доставка",
      price: "15 000 ₸",
      oldPrice: "23 000 ₸",
      currency: "",
      features: [
        "Витрина для доставки",
        "Заказ домой с того же меню",
        "Приложение курьера с трекингом",
        "Кухня (KDS)",
        "Касса + Kaspi QR",
        "Чат-поддержка",
      ],
      cta: "Подключить",
    },
    pro: {
      name: "Pro",
      price: "25 000 ₸",
      oldPrice: "39 000 ₸",
      currency: "",
      features: [
        "До 50 столов",
        "Всё из Starter",
        "Официант PWA",
        "Кухня (KDS)",
        "Касса + Kaspi QR",
        "AI-помощник",
        "Бронирование столов",
        "Чат-поддержка",
      ],
      cta: "Подключить",
    },
    enterprise: {
      name: "Enterprise",
      price: "40 000 ₸",
      oldPrice: "62 000 ₸",
      currency: "",
      features: [
        "Безлимит столов",
        "Multi-branch (сеть)",
        "Кастом-интеграции",
        "Брендирование под кафе",
        "SLA + приоритет-support",
        "Выделенный менеджер",
      ],
      cta: "Обсудить",
    },
    network: {
      name: "Сеть",
      price: "По запросу",
      oldPrice: "",
      currency: "",
      features: [
        "Несколько заведений в одной панели",
        "Сводка выручки по всей сети",
        "White-label для всех точек",
        "Оплата помесячно за каждую точку",
        "Кастом-интеграции и онбординг",
        "Выделенный менеджер",
      ],
      cta: "Связаться",
    },
  },
  builder: {
    label: "Конструктор",
    title: "Соберите",
    accent: "свой тариф",
    subtitle:
      "Как у операторов связи: база за 2 000 ₸ — а дальше двигайте ползунки. Платите только за то, чем реально пользуетесь.",
    presets: "Готовые наборы",
    presetTakeaway: "Точка навынос",
    presetCafe: "Кафе с залом",
    presetResto: "Ресторан",
    presetMax: "Всё включено",
    base: "База платформы",
    baseHint: "QR-меню-витрина, касса (веб + Windows), админка, учёт остатков, навынос и самовывоз",
    hall: "Зал и столы",
    hallHint: "QR на столах, заказы с телефона гостя, приложение официанта",
    hallOptions: ["Без зала", "До 10 столов", "До 30 столов", "До 50 столов", "Безлимит"],
    staff: "Сотрудники",
    staffHint: "Аккаунты персонала: кассиры, официанты, повара…",
    staffOptions: ["До 5", "До 10", "До 20", "Безлимит"],
    modules: "Модули",
    mDelivery: "Доставка",
    mDeliveryHint: "Витрина доставки, курьеры на живой карте, чат с гостем",
    mAi: "AI-ассистент",
    mAiHint: "Чат-помощник для гостя и персонала",
    mWl: "Свой бренд",
    mWlHint: "Логотип и имя кафе вместо Orda OS (white label)",
    included: "Уже включено в любую сборку",
    includedList: ["Кухня (KDS)", "Бронирование", "Лояльность", "Склад и закуп", "Кабинет бухгалтера", "Аналитика", "6 языков меню", "Kaspi QR"],
    total: "Ваш тариф",
    perMonth: "/мес",
    matches: "= тариф",
    free: "вкл.",
    cta: "Получить расчёт",
    ctaHint: "Конфигурация уйдёт менеджеру вместе с заявкой — перезвоним, подтвердим цену и подключим.",
  },
  faq: {
    label: "FAQ",
    title: "Частые",
    accent: "вопросы",
    items: [
      {
        q: "Сколько времени уходит на внедрение?",
        a: "1 день. Мы создаём ваш тенант, загружаем меню (можем по фото), печатаем QR-коды на столы, обучаем персонал за 30 минут. Уже в первый вечер гости начинают заказывать через QR.",
      },
      {
        q: "Что с данными моего кафе?",
        a: "Данные хранятся на Supabase (PostgreSQL + RLS isolation). Каждое кафе изолировано — ваш повар видит только ваши заказы. По запросу — выгрузка всех данных в CSV.",
      },
      {
        q: "Подходит ли это маленькому кафе с 4 столами?",
        a: "Да. Минимальный тариф Starter покрывает до 10 столов. Часто маленькие кафе получают самый большой эффект — официант один, а QR-меню снимает с него половину работы.",
      },
      {
        q: "Нужна ли касса (онлайн-касса для Казахстана)?",
        a: "Orda OS — это управление заказами и оплатой через Kaspi QR. Фискализация (онлайн-касса) — отдельная интеграция, добавим под вас если используете Salyk/онлайн-кассу.",
      },
      {
        q: "А если интернет упал?",
        a: "Платформе хватает обычного интернета — подойдёт даже мобильный. Данные в облаке, ничего не теряется и доступно с любого устройства. Для точек с нестабильной связью подбираем решение под ваш формат.",
      },
    ],
  },
  lead: {
    label: "Заявка",
    title: "Есть кафе?",
    subtitle:
      "Оставьте номер — перезвоню в течение часа, покажу платформу на вашем меню и посчитаю тариф под ваш формат.",
    nameLabel: "Ваше имя",
    namePlaceholder: "Алмас",
    phoneLabel: "Телефон",
    cafeLabel: "Название кафе",
    cafePlaceholder: "Café Әлем",
    cityLabel: "Город",
    noteLabel: "Сообщение",
    notePlaceholder: "Сколько столов, что важно, какие интеграции нужны...",
    submit: "Получить предложение",
    submitting: "Отправляем...",
    privacy:
      "Нажимая «Отправить», вы соглашаетесь с обработкой данных для обратной связи. Никакого спама.",
    successTitle: "Спасибо!",
    successBody:
      "Ваша заявка получена. Перезвоним в течение часа — будем рады познакомиться 🤝",
    configAttached: "К заявке приложена конфигурация из конструктора",
    errors: {
      name_too_short: "Имя слишком короткое (минимум 2 символа).",
      name_too_long: "Имя слишком длинное (максимум 80 символов).",
      phone_invalid: "Телефон выглядит некорректно. Минимум 8 цифр.",
      note_too_long: "Сообщение слишком длинное (максимум 1000 символов).",
      rate_limited: "Слишком много заявок с этого IP. Попробуйте через час или напишите в Telegram.",
      DB_ERROR: "Не удалось сохранить заявку. Попробуйте ещё раз или напишите в Telegram.",
      INVALID_JSON: "Ошибка отправки данных. Обновите страницу.",
      unknown: "Что-то пошло не так. Попробуйте ещё раз или напишите в Telegram.",
    },
  },
  contact: {
    title: "Связаться",
    subtitle: "Напишите — отвечу в течение часа.",
    whatsapp: "WhatsApp",
    telegram: "Telegram",
    instagram: "Instagram",
    email: "Email",
    message: "Здравствуйте! Интересует Orda OS для моего кафе.",
  },
  waiter: {
    eyebrow: "Гость · цифровой помощник",
    title: "Ваш цифровой",
    accent: "официант",
    body:
      "Интерактивный 3D-помощник встречает гостя, подсказывает блюда под бюджет и настроение и ведёт прямо к заказу — на трёх языках, без очереди и ожидания.",
    chips: ["Следит за курсором", "3D в реальном времени", "AI-советчик"],
    cta: "Живое демо",
    hint: "Двигайте курсором — он следит за вами",
  },
  band: {
    eyebrow: "Orda OS",
    line: "Меню, кухня, касса и склад — один организм.",
    sub: "Одна платформа вместо десяти сервисов. Запуск за один день.",
    cta: "Подключить кафе",
  },
  footer: {
    copyright: "© 2026 Orda OS · e-menu.bar",
    tagline: "Сделано в Казахстане 🇰🇿",
    privacy: "Конфиденциальность",
    terms: "Условия",
    download: "Касса для Windows",
  },
  legal: {
    back: "← На главную",
  },
};
